import Vue from 'vue'
import template from './index.pug'
import Frame2712 from 'assets/images/info-bono/Group 2712.svg'
import Frame2706 from 'assets/images/info-bono/Group 2706.svg'
import LogoGE from 'assets/images/logo.svg'
import LogoGC from 'assets/images/logo_prod_GC.png'

export default Vue.extend({
  template: template(), 
  
  components: {
  },

  computed: {
  },

  data() {
    return {
      frame2712:Frame2712,
      frame2706:Frame2706,
      logoGe:LogoGE,
      logoGc:LogoGC
    }
  },

  methods: {
  }
})